import { Link } from 'react-router-dom'

interface ServiceCardProps {
  title: string
  icon: string
  href: string
  index?: number
  ctaLabel?: string
}

function ServiceCard({ title, icon, href, index = 0, ctaLabel = 'Solicitar turno →' }: ServiceCardProps) {
  return (
    <div
      className="float rounded-xl p-6 cursor-pointer bg-primary/10 border border-primary/10 shadow-sm hover:shadow-md"
      style={{ transitionDelay: `${Math.min(index * 60, 300)}ms` }}
    >
      <div className="text-primary text-3xl mb-4">
        <i className={`${icon} text-3xl`}></i>
      </div>
      <h3 className="text-lg font-semibold text-text-primary mb-2">{title}</h3>
      <Link to={href} className="text-accent hover:text-secondary font-medium text-sm">
        {ctaLabel}
      </Link>
    </div>
  )
}

export default ServiceCard